import type { IDesignGaps } from '@alfa-bank/site-util-create-widget/src/models';

export const mapSpacerVerticalToStylerObj: Record<string, IDesignGaps['indent']> = {
    '2x': 4,
    xs: 8,
    s: 12,
    m: 16,
    l: 20,
    xl: 24,
    '2xl': 32,
    '3xl': 40,
    '4xl': 48,
    '5xl': 72,
};

export type TStylerWithSpacer = IDesignGaps['indent'] | keyof typeof mapSpacerVerticalToStylerObj;

// TODO: Удалить, как только виджеты использующие данный хелпер перестанут в пропсы принимать значения для deprecated-spacer-vertical
// Виджеты: cpas-banner -> benefits, pay-system-offers -> card-carousel
/** @deprecated Принимает значения как styler так и space-vertical и возвращает число*/
export const mapSpacerVerticalToStyler = (space: TStylerWithSpacer): IDesignGaps['indent'] => {
    if (typeof space === 'number') {
        return space;
    }

    if (space in mapSpacerVerticalToStylerObj) {
        return mapSpacerVerticalToStylerObj[space];
    }

    return 0;
};
